import Storage from '@/lib/Storage'
import { isEmpty } from '@/utils/isEmpty'
import StackAPI from '@/lib/StackAPI'
import { captureException } from '@sentry/react'
import { Filters } from '../types/PhysicalOrders'

const PATH = '/partners/vendor/orders/batches'
const ERROR = 'Failed to download. Try again later.'

export type GetBatchCsvParams = {
  batchId?: number
  batchIds?: number[]
  filters?: Filters
}

export type GetBatchCsvResponse =
  | {
      data: string
      filename: string
    }
  | {
      error: string
    }

export const getBatchCsv = async ({
  batchId,
  batchIds,
  filters = {}
}: GetBatchCsvParams): Promise<GetBatchCsvResponse> => {
  const role = Storage().getActiveRole()

  if (isEmpty(role)) return { error: 'no active role' }

  const { get } = StackAPI()

  const headers = {
    Accept: 'text/csv',
    'Content-Type': 'text/csv'
  }

  const params = {
    batch_ids: batchIds,
    filter_by_late: filters.late ? 1 : null,
    filter_by_pending: filters.pending ? 1 : null,
    filter_by_refunded: filters.refunded ? 1 : null
  }

  let path = batchId ? `${PATH}/${batchId}` : PATH
  path = `${path}.csv`

  const request = {
    path,
    params,
    headers,
    responseType: 'blob'
  }

  try {
    const response = await get<string>(request)
    const contentDisposition = response.headers?.['content-disposition']

    let filename = 'download.csv'

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename=(.*)/)
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '').trim()
      }
    }

    return { data: response.data, filename }
  } catch (error) {
    captureException(error, { extra: { role, batchId, batchIds, filters } })
    return { error: ERROR }
  }
}
